import React from 'react'
import styled from 'styled-components'

const FilterSection = ({ filter, setFilter = () => {}, refetch }) => {
  const onChange = (e) => {
    setFilter(e.target.value)
    refetch()
  }
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'today', label: 'Due Today' },
    { value: 'overdue', label: 'Overdue' }
  ]
  return (
    <Wrapper>
      {filters.map(({ value, label }) => (
        <div className="radio-container" key={value}>
          <input type="radio" name="dueCheckbox" id={value} checked={filter === value} onChange={onChange} value={value} />
          <div className="radio-indicator" />
          <label htmlFor="all">{label}</label>
        </div>
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-left: 8px;
  margin-right: 8px;
  border: 1px solid #3f76e6;
  border-radius: 4px;
  &>div {
    display: inline-block;
    margin-right: 12px;
    margin-top: 10px;
    margin-bottom: 10px;
    &:first-of-type {
    margin-left: 12px;
    }
  }
  .radio-container {
    padding-left: 18px;
    position: relative;
    input {
    position: absolute;
    cursor: pointer;
    z-index: 1;
    top: 0;
    left: -13px;
    width: calc(100% + 13px);
    height: 25px;
    opacity:0;
      &+.radio-indicator {
        z-index: 0;
        border: 1px solid #8e8e8e;
        position: absolute;
        left: 0;
        top: 5px;
        border-radius: 50%;
        width: 13px;
        height: 13px;
      }
      &:checked+.radio-indicator {
        background-color: #3f76e6;
        border: 1px solid #3f76e6;
        box-shadow: inset 0px 0px 0px 2px white;
      }
    }
  }
`;

export default FilterSection
